import React, { FunctionComponent, useMemo } from 'react';
import { UniversePage } from '../../generated/contentful-generated-types';
import { showForUserMultiple } from '../../utils/contentful';
import { SimpleCardRow } from '../Tiles/SimpleCardRow';
import { isLoggedIn, useGetLogin, useIsRegisteredNonBuyer, useIsReseller } from '../../hooks/useLogin';
import styled from 'styled-components';
import { getColorFromCode } from '../../common/constants';
import { useAlgoliaSearchByObjectIds } from '../../hooks/useAlgoliaSearchByObjectIds';

type CurrentSelectionProps = Pick<UniversePage, 'currentSelectionTitle' | 'currentSelectionCollection' | 'hideCurrentSelection'>;
export const CurrentSelection: FunctionComponent<CurrentSelectionProps> = ({ currentSelectionTitle, currentSelectionCollection, hideCurrentSelection }) => {
  const useLoginResult = useGetLogin();
  const loggedIn = isLoggedIn(useLoginResult);
  const reseller = useIsReseller();
  const isRegisteredNonBuyer = useIsRegisteredNonBuyer();

  const currentSelectionCollectionFiltered = currentSelectionCollection?.items?.filter(item =>
    showForUserMultiple(item?.showOnlyForMultiple, reseller, loggedIn, isRegisteredNonBuyer)
  );
  const selectionItemsCollection = currentSelectionCollectionFiltered && currentSelectionCollectionFiltered[0]?.selectionItemsCollection;
  const first8items = selectionItemsCollection?.items?.slice(0, 8);
  const showSelection = hideCurrentSelection != true && first8items != undefined && first8items.length > 0;

  const selectedProductsIds = first8items?.map(item => item?.sys?.id).filter(id => id !== undefined && id !== null) as string[];

  const objectIDs = useMemo(() => (selectedProductsIds?.length > 0 ? selectedProductsIds : []), [selectedProductsIds?.join(',')]);
  const hitsPerPage = objectIDs.length;
  const hits = useAlgoliaSearchByObjectIds({ objectIDs, hitsPerPage });
  return (
    <>
      {showSelection && (
        <StyledContainer>
          <StyledTitle>
            <h2>{currentSelectionTitle}</h2>
          </StyledTitle>
          <SimpleCardRow items={first8items} onClick={() => {}} showDescription={false} asCarousel={true} hits={hits} />
        </StyledContainer>
      )}
    </>
  );
};

const StyledContainer = styled.div`
  width: 100%;

  margin-bottom: -32px; //to compensate the extra margin needed for shadows

  @media (max-width: 1024px) {
    padding: 0 4px;
  }
  @media (max-width: 768px) {
    padding: 0 4px;
  }
  @media (max-width: 375px) {
    margin-bottom: 0px;
  }

  .carousel-container {
    margin-top: 16px;
    padding: 0;
    @media (max-width: 380px) {
      padding: 0 8px;
    }
  }

  .simple-card {
    margin-bottom: 24px;
    @media (max-width: 768px) {
      margin-right: 4px;
    }
    @media (max-width: 380px) {
      margin-bottom: 0px;
    }
    .price-range {
      display: none;
    }
  }
  .simple-card-image {
    height: 149px;
  }

  .simple-card-title {
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
`;

const StyledTitle = styled.div`
  display: flex;
  align-items: baseline;
  gap: 16px;
  h2 {
    color: ${getColorFromCode('exa black', '#323232')};
    font-family: 'Styrene Medium';
    font-size: 20px;
    font-style: normal;
    line-height: 30.54px;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 20px;
      flex: 1 0 0;
    }
  }
  @media (max-width: 576px) {
    h2 {
      font-size: 18px;
      flex: 1 0 0;
    }
    border-left-width: 6px;
    padding-left: 8px;
  }
`;
